'use strict';

/**
 * @ngdoc filter
 * @name webAgro1App.filter:capitalize
 * @function
 * @description
 * # capitalize
 * Filter in the webAgro1App.
 */
angular.module('webAgro1App').filter('capitalize', function() {
  return function(text) {
    if (text) {
      var string = text.split('_').join(' ').toLowerCase();
      return string.replace( /(^|\s)([a-zà-ú])/g , function(m, p1, p2) {
        return p1+p2.toUpperCase();
      });
    }
  };
});
